import ButtonMaterial, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { ElementRef, forwardRef, ReactNode } from 'react';
import LoadingButton, { ILoadingButtonProps } from '../LoadingButton';

type ButtonDangerProps = Omit<MuiButtonProps, 'color' | 'variant' | 'children'> &
  Omit<ILoadingButtonProps, 'color' | 'variant' | 'isLoading' | 'children' | 'sx'> & {
    isLoading?: boolean;
    children: ReactNode;
  };

const styles = {
  '&:hover, &:focus, &:active': {
    borderColor: 'error.dark',
  },
  borderColor: 'error.dark',
  color: 'error.dark',
};

const ButtonDanger = forwardRef<ElementRef<typeof ButtonMaterial | typeof LoadingButton>, ButtonDangerProps>(
  ({ children, isLoading = false, ...props }, ref) =>
    isLoading ? (
      <LoadingButton {...props} color="secondary" isLoading={isLoading} ref={ref} sx={styles} variant="outlined">
        {children}
      </LoadingButton>
    ) : (
      <ButtonMaterial {...props} color="secondary" ref={ref} sx={styles} variant="outlined">
        {children}
      </ButtonMaterial>
    )
);

ButtonDanger.displayName = 'ButtonDanger';

export default ButtonDanger;
